import {
    noop,
} from 'lodash'
import Card from 'app/shared-components/Card'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import useTableStyles from 'app/tss/table.styles'
import useCardForTableStyles from 'app/tss/cardForTable'
import requestConfig from 'app/requests/Prebooking.requests'
import useLabel from 'app/hooks/useLabel'

import tableConfig from './preBookings.config'

const PreBookings = ({
    serviceCenterId,
    className,
}: Readonly<{ serviceCenterId: number, className?: string }>) => {
    const l = useLabel()
    const {
        classes: cardClasses,
    } = useCardForTableStyles()
    const {
        classes: tableClasses,
    } = useTableStyles()

    return (
        <Card
            title={l('PRE_BOOKINGS')}
            className={cardClasses.root}
        >
            <SkyNetTable
                name="PreBookings"
                tableConfig={tableConfig}
                customUrl={requestConfig.getPreBookingsByServiceCenter().url}
                filters={{
                    serviceCenterId,
                }}
                defaultSort={{
                    field: 'requestedHandover',
                    direction: 'desc',
                }}
                simple
                showSearch
                className={className || tableClasses.table}
                onRowClick={noop}
            />
        </Card>
    )
}

export default PreBookings
